import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../../assets/css/meucorreios/dialog.css';
import '../../../assets/css/meucorreios/icones-correios.css';
import { CONSULTAR_TOKEN } from '../../../services/meuCorreios';
import useFetch from '../../../components/hooks/useFetch';
import { parseISO, format } from 'date-fns';
import Tabela from '../../../components/tabela/Tabela';

const FormHistoricoToken = () => {
  const { t } = useTranslation();
  const { request, data } = useFetch();
  const location = useLocation();
  const dados = location.state;
  const navigate = useNavigate();
  React.useEffect(() => {
    request(CONSULTAR_TOKEN(dados?.idCorreios));
  }, []);
  const tableMetadata = [
    // { key: 'numero', value: t('principal.token_history.table.number') },
    { key: 'funcionalidade', value: t('principal.token_history.table.functionality') },
    {
      key: 'dataCadastro',
      value: t('principal.token_history.table.registration_date'),
      render: (text) => format(parseISO(text), 'dd-MM-yyyy HH:mm:ss'),
    },
    {
      key: 'meioEnvio',
      value: t('principal.token_history.table.delivery_method'),
      render: (text) => (text === 'C' ? t('principal.token_history.table.mobile') : t('principal.token_history.table.email')),
    },
    { key: 'destino', value: t('principal.token_history.table.destination') },
  ];
  /*const fechar = (ev) => {
    ev.preventDefault();
    acaoCancelar();
  };*/
  return (
    <>
      <div className="conteudo">
        <p>
          {t('principal.token_history.description')}
        </p>
        <div className="cards-container">
          {data && (
            <div className="dados">
              <Tabela headers={tableMetadata} dados={data} />
            </div>
          )}
        </div>
      </div>

      <div className="dialog-footer">
        <button
          className="btn-txt btn-fecha-dialog"
          onClick={() => navigate('/principal')}
        >
          {t('principal.forms.buttons.back')}
        </button>
      </div>
    </>
  );
};
export default FormHistoricoToken;
